var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24.999 21.874",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.217 5.4684h-0.8087c-0.0922-1.3575-0.4847-2.3984-1.7638-3.6772-0.3052-0.30515-0.7995-0.30515-1.1047 0-0.3051 0.30516-0.3051 0.79952 0 1.1047 0.9134 0.91338 1.2171 1.5718 1.3018 2.5725h-0.7494c-0.4315 0-0.7812 0.34978-0.7812 0.7812v3.906c0 0.4314 0.3497 0.7812 0.7812 0.7812h1.5624v4.2967c0 1.0768-0.8762 1.953-1.953 1.953-1.0769 0-1.953-0.8762-1.953-1.953v-12.89c0-1.2924-1.0513-2.3436-2.3437-2.3436h-12.499c-1.2923 0-2.3436 1.0513-2.3436 2.3436v17.968h-0.7812c-0.43142 0-0.7812 0.3498-0.7812 0.7812s0.34978 0.7812 0.7812 0.7812h18.749c0.4314 0 0.7812-0.3498 0.7812-0.7812s-0.3498-0.7812-0.7812-0.7812h-0.7812v-2.1575c0.5591 0.3751 1.2306 0.5951 1.953 0.5951 1.9385 0 3.5154-1.5769 3.5154-3.5154v-4.2967c0.4314 0 0.7812-0.3498 0.7812-0.7812v-3.906c0-0.43142-0.3498-0.7812-0.7812-0.7812zm-8.1779 3.906c0 0.43137-0.3498 0.78117-0.7812 0.78117h-10.205c-0.43147 0-0.7812-0.3498-0.7812-0.78117v-5.8838c0-0.36826 0.34973-0.78121 0.7812-0.78121h10.205c0.4314 0 0.7812 0.34974 0.7812 0.78121z",
    fill: "#000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.841c46f3cafbfa46103703cbef0a1579.svg";
export { ForwardRef as ReactComponent };